import api from "@/lib/axios";

export const login = async ({ email, password }) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data.data; // { token, user }
};

// Oturumu httpOnly refresh çerezinden geri alır — access token'a bakmıyor, süresi dolmuş
// olsa da çalışır. Sunucu her çağrıda çerezi de döndürüyor (rotasyon).
export const refreshToken = async () => {
  const { data } = await api.post("/auth/refresh");
  return data.data; // { token, user }
};

export const logout = async () => {
  const { data } = await api.post("/auth/logout");
  return data.data;
};

export const getMe = async () => {
  const { data } = await api.get("/auth/me");
  return data.data;
};

export const updateProfile = async ({ fullName }) => {
  const { data } = await api.patch("/auth/profile", { fullName });
  return data.data;
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const { data } = await api.patch("/auth/password", {
    currentPassword,
    newPassword,
  });
  return data.data;
};

// Davet uçları KİMLİKSİZ: davet edilen kişinin henüz oturumu yok. Yetki token'ın kendisi.
export const getInvite = async (token) => {
  // encodeURIComponent şart: React Router %2F'yi çözüyor, yani token'a bölü işareti sokan bir
  // link tarayıcıyı /panel/v1 altında BAŞKA bir yola kimlikli istek attırabiliyordu.
  const { data } = await api.get(`/auth/invite/${encodeURIComponent(token)}`);
  return data.data;
};

export const acceptInvite = async (token, password) => {
  const { data } = await api.post(`/auth/invite/${encodeURIComponent(token)}`, {
    password,
  });
  return data.data;
};
